import * as React from 'react';
import { Table, Button } from 'reactstrap';
import { DownArrow, UpArrow } from '../../components/Icons';
import { useEffect } from 'react';

const workflowsStyles = require('./workflows.css');
const iconStyles = require('../../components/icons.css');

export const WorkflowsTable = ({
  state,
  getTableProps,
  headerGroups,
  getTableBodyProps,
  rows,
  prepareRow,
  pageOptions,
  page,
  gotoPage,
  previousPage,
  nextPage,
  canPreviousPage,
  canNextPage,
  handleRowClick,
}) => {
  const filters = state.filters;
  const pageIndex = state.pageIndex;

  useEffect(() => {
    // filters changed
    gotoPage(0);
  }, [filters]);

  return (
    <div className={workflowsStyles.fullHeight}>
      <div className={workflowsStyles.fullHeightTableContainer}>
        <div className={workflowsStyles.fitContentTableContainer}>
          <Table
            {...getTableProps()}
            striped
            className={workflowsStyles.workflowsTable}
          >
            <thead>
              {headerGroups.map((headerGroup) => (
                <tr {...headerGroup.getHeaderGroupProps()}>
                  {headerGroup.headers.map((column) => {
                    const isDescription = column.id === 'description';
                    const headerProps = column.getHeaderProps(
                      column.getSortByToggleProps()
                    );
                    return (
                      <th
                        {...headerProps}
                        className={
                          isDescription
                            ? `${headerProps.className || ''} ${workflowsStyles.descriptionColumn}`.trim()
                            : headerProps.className
                        }
                      >
                        {column.render('Header')}
                        <div>
                          {column.canFilter ? column.render('Filter') : null}
                        </div>
                        <Button
                          className={workflowsStyles.sortButton}
                          size="sm"
                          color="link"
                        >
                          {column.isSorted ? 'sorted ' : 'sort'}
                          <span>
                            {column.isSorted ? (
                              column.isSortedDesc ? (
                                <DownArrow
                                  fill="#007bff"
                                  class={iconStyles.sortButton}
                                />
                              ) : (
                                <UpArrow
                                  fill="#007bff"
                                  class={iconStyles.sortButton}
                                />
                              )
                            ) : (
                              ''
                            )}
                          </span>
                        </Button>
                      </th>
                    );
                  })}
                </tr>
              ))}
            </thead>
            <tbody {...getTableBodyProps()}>
              {page.map((row) => {
                prepareRow(row);
                return (
                  <tr
                    {...row.getRowProps()}
                    className={workflowsStyles.selectableRow}
                  >
                    {row.cells.map((cell) => {
                      const isDescription = cell.column.id === 'description';
                      const cellProps = cell.getCellProps({
                        onClick: (e) =>
                          handleRowClick && handleRowClick(row, cell, e),
                      });
                      return (
                        <td
                          {...cellProps}
                          className={
                            isDescription
                              ? `${cellProps.className || ''} ${workflowsStyles.descriptionColumn}`.trim()
                              : cellProps.className
                          }
                        >
                          {cell.render('Cell')}
                        </td>
                      );
                    })}
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </div>
        <div className={workflowsStyles.pagination}>
          <Button onClick={() => previousPage()} disabled={!canPreviousPage}>
            Previous Page
          </Button>
          <Button onClick={() => nextPage()} disabled={!canNextPage}>
            Next Page
          </Button>
          <div>
            Page{' '}
            <em>
              {pageIndex + 1} of {pageOptions.length}
            </em>
          </div>
        </div>
        Total Rows: {rows.length}
      </div>
    </div>
  );
};
